export const SortSelect = (element: HTMLElement) => {
    const sortByElements = Array.from(
        element.querySelectorAll("[data-sort-by]"),
    );
    const sortDirectionElements = Array.from(
        element.querySelectorAll("[data-sort-direction]"),
    );

    const selectedByValue = sortByElements
        .find(
            (elem) => elem.attributes.getNamedItem("data-sort-active") !== null,
        )
        ?.attributes?.getNamedItem("data-sort-by")?.value;
    const selectedDirectionValue = sortDirectionElements
        .find(
            (elem) => elem.attributes.getNamedItem("data-sort-active") !== null,
        )
        ?.attributes?.getNamedItem("data-sort-direction")?.value;

    sortByElements.forEach((elem) => {
        elem.addEventListener("click", () => {
            const url = new URL(window.location.href);
            const elemValue =
                elem.attributes.getNamedItem("data-sort-by")?.value;

            if (elemValue !== selectedByValue) {
                url.searchParams.set("sort-by", elemValue!);
                url.searchParams.set(
                    "sort-dir",
                    selectedDirectionValue ??
                        sortDirectionElements[0].attributes.getNamedItem(
                            "data-sort-direction",
                        )!.value,
                );
            } else {
                url.searchParams.delete("sort-by");
                url.searchParams.delete("sort-dir");
            }

            url.searchParams.delete("page");

            window.location.href = url.toString();
        });
    });

    sortDirectionElements.forEach((elem) => {
        elem.addEventListener("click", () => {
            const url = new URL(window.location.href);
            const elemValue = elem.attributes.getNamedItem(
                "data-sort-direction",
            )?.value;

            if (elemValue !== selectedDirectionValue) {
                url.searchParams.set(
                    "sort-by",
                    selectedByValue ??
                        sortByElements[0].attributes.getNamedItem(
                            "data-sort-by",
                        )!.value,
                );
                url.searchParams.set("sort-dir", elemValue!);
            } else {
                url.searchParams.delete("sort-by");
                url.searchParams.delete("sort-dir");
            }

            url.searchParams.delete("page");

            window.location.href = url.toString();
        });
    });
};
